import { useCallback } from "react";
import { Box, Button, Typography } from "@mui/material";
import { Publish } from "@mui/icons-material";
import type { FeatureCollection } from "geojson";
import { LoadingComponent } from "../../../helpers";
import { ValidationErrorsContext } from "../../ImportTable/ImportTable/shared/hooks/ValidationErrorsContext";
import { JobFormFields } from "../../shared/JobFormFields";
import type { EditableJsonKeys } from "../../../helpers/JobMap/JobMap.types";
import { useSingleImportFormViewModel } from "./SingleImportForm.vm";
import { ManualEntryFormProps } from "./SingleImportForm.types";
import "./SingleImportForm.css";

export function SingleImportForm(props: ManualEntryFormProps) {
	const vm = useSingleImportFormViewModel(props);

	const onGeometryEdit = useCallback(
		(_jobId: string, jsonKey: EditableJsonKeys, updated: FeatureCollection) => {
			vm.updateJobFiles(jsonKey, updated);
		},
		[vm.updateJobFiles],
	);

	return (
		<div className="manual-entry-form">
			{vm.loading && (
				<Box className="loading-overlay">
					<LoadingComponent />
					<Typography variant="h5">Submitting Job...</Typography>
				</Box>
			)}
			<ValidationErrorsContext.Provider value={vm.localValidationErrors}>
				<Box sx={{ pt: 1 }}>
					<JobFormFields
						job={vm.currentJob}
						columnContext={vm.columnContext}
						dropdownOptions={vm.dropdownOptions}
						branches={vm.branches}
						isVisible={vm.isVisible}
						onGeometryEdit={onGeometryEdit}
						isSuperUser={vm.isSuperUser}
					/>
				</Box>
			</ValidationErrorsContext.Provider>
			<div className="required-fields-note">
				<Typography>
					Fields marked with <span className="required-asterisk">*</span> are required
				</Typography>
			</div>
			<Button fullWidth variant="contained" color="primary" disabled={!vm.isFormValid} onClick={vm.onSubmit}>
				<Publish className="icon-in-button" /> Create Job
			</Button>
		</div>
	);
}
